import { toast } from 'react-toastify'
import Axios from 'axios'
import i18next from 'i18next'
import config from '../config'
import userManager from './UserManager'
import { loadLocale } from './utils'

export const axios = Axios.create({
  baseURL: config.api.url,
  headers: {
    'Accept-Language': loadLocale(),
  },
  validateStatus: status => {
    return status >= 200 && status < 300
  },
})

let isHandling401 = false
let pendingQueue: Array<{
  resolve: (value: any) => void
  reject: (reason?: any) => void
  config: any
}> = []

const processQueue = (error: any, token: string | null = null) => {
  pendingQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      if (token) {
        prom.config.headers.Authorization = `Bearer ${token}`
      }
      axios(prom.config).then(prom.resolve).catch(prom.reject)
    }
  })
  pendingQueue = []
}

axios.interceptors.request.use(
  async req => req,
  err => Promise.reject(err instanceof Error ? err : new Error(String(err))),
)

let isShowingBackendDownMessage = false

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    if (!error.response) {
      if (error.config.url == 'api/auth/me') {
        if (!isShowingBackendDownMessage) {
          isShowingBackendDownMessage = true
          toast(i18next.t('common:backendDown'), { type: 'error', autoClose: 30000 })
          setTimeout(() => {
            isShowingBackendDownMessage = false
          }, 30000)
        }
      }
      return Promise.reject(error)
    }

    if (error.response?.status !== 401) {
      return Promise.reject(error)
    }

    if (originalRequest._retry) {
      return Promise.reject(error)
    }

    if (isHandling401) {
      return new Promise((resolve, reject) => {
        pendingQueue.push({ resolve, reject, config: originalRequest })
      })
    }

    isHandling401 = true
    originalRequest._retry = true

    try {
      await userManager.ensureValidToken()
      processQueue(null, null)
      isHandling401 = false

      return axios(originalRequest)
    } catch (renewError) {
      processQueue(renewError, null)
      isHandling401 = false
      userManager.signIn()

      return Promise.reject(error)
    }
  },
)

export default axios
